var BaseView = $.extend({/* BaseView */}, Base, {

	viewSelector: ''
})